class InstallReferrer {
	static getInstallReferrerInfo() {
		return null;
	}
}
export { InstallReferrer };
